export const isLocalhost = process.env.REACT_APP_IS_DEV_PROXY === 'true';
